
// google auth provider, as used in User datastore
export const AUTH_PROVIDER_GOOGLE = "GOOGLE";

// subscription statuses from Chargify
export const SUBSCRIPTION_STATUSES = {
  TRIALING: "trialing",
  TRIAL_ENDED: "trial_ended",
  ACTIVE: "active",
  SOFT_FAILURE: "soft_failure",
  PAST_DUE: "past_due",
  CANCELED: "canceled",
  UNPAID: "unpaid",
  EXPIRED: "expired",
  ON_HOLD: "on_hold",
  ASSESSING: "assessing",
  PENDING: "pending",
  FAILED_TO_CREATE: "failed_to_create"
}



// WEBPACK FOOTER //
// ./src/constants/index.js